// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"FX-z","subtitle":"GX-z","wrapper":"HX-z","leftArrow":"IX-z","rightArrow":"JX-z"};